var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 19,
    viewBox: "0 0 63 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 18H3C1.89543 18 1 17.1046 1 16V3C1 1.89543 1.89543 1 3 1H5",
    stroke: "#1A1B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 15V5.2H11.938V15H13.8ZM17.2384 15V8.098L21.4944 15H23.4824V5.2H21.6344V12.116L17.3924 5.2H15.3904V15H17.2384ZM29.0812 15V6.796H32.0352V5.2H24.2652V6.796H27.2332V15H29.0812ZM39.7845 12.382C39.7145 11.486 39.2805 10.758 38.6085 10.338C39.4205 9.918 39.9245 9.232 39.9245 8.224C39.9245 6.446 38.7205 5.2 36.6765 5.2H32.6585V15H34.5205V11.318H36.6345C37.3625 11.318 37.8805 11.85 37.9505 12.592L38.1885 15H40.0225L39.7845 12.382ZM36.5925 6.754C37.6845 6.754 38.1325 7.44 38.1325 8.224C38.1325 9.008 37.6845 9.722 36.5925 9.722H34.5205V6.754H36.5925ZM45.6505 15.112C48.4925 15.112 50.5925 12.984 50.5925 10.1C50.5925 7.216 48.4925 5.088 45.6505 5.088C42.7945 5.088 40.6945 7.216 40.6945 10.1C40.6945 12.984 42.7945 15.112 45.6505 15.112ZM45.6365 13.502C43.8585 13.502 42.5565 12.06 42.5565 10.1C42.5565 8.14 43.8585 6.684 45.6365 6.684C47.4285 6.684 48.7305 8.14 48.7305 10.1C48.7305 12.06 47.4285 13.502 45.6365 13.502Z",
    fill: "#1A1B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 18H60C61.1046 18 62 17.1046 62 16V3C62 1.89543 61.1046 1 60 1H58",
    stroke: "#1A1B1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro);
export default __webpack_public_path__ + "static/media/Intro.3d255ada7f03049b15e0553159076b42.svg";
export { ForwardRef as ReactComponent };